import { render } from "./ConversationTranscript.vue?vue&type=template&id=68f5380a&scoped=true&lang=pug"
import script from "./ConversationTranscript.vue?vue&type=script&lang=js"
export * from "./ConversationTranscript.vue?vue&type=script&lang=js"

import "./ConversationTranscript.vue?vue&type=style&index=0&id=68f5380a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f5380a"]])

export default __exports__